// Define action types
export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_ORDER_ASYNC = 'CREATE_ORDER_ASYNC';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_ASYNC = 'GET_ORDERS_ASYNC';
export const CLEAR_DATA_ORDERS = 'CLEAR_DATA_ORDERS';
export const ORDER_FAILURE = 'ORDER_FAILURE';
